import { NO_KEY, YES_KEY } from '@/common/constants';
import { CategoryTypeDto } from '@/modules/ProcessingDefinition/Services/Services.types';

export enum PayoutDefinitionField {
  payoutDefinitionName = 'payoutDefinitionName',
  mpTableId = 'mpTableId',
  covTableId = 'covTableId',
  isLimited = 'isLimited',
  categories = 'categories',
  columnsCount = 'columnsCount',
}

export const IS_LIMITED_OPTIONS = [
  { label: 'Yes', value: YES_KEY },
  { label: 'No', value: NO_KEY },
];

export interface PayoutOrderService {
  /**
   * Stable unique identifier for a service row. Derived from the backend's
   * `sequence_id` when available, otherwise a client-generated uid for newly
   * added services. Used for all UI matching (select/remove/plan update/validation)
   * because `id` (service_id) can be duplicated within a single category.
   */
  rowId: string;
  id: string;
  name: string;
  serviceType: string;
  sequenceId?: number;
  plans: PayoutOrderPlan[];
}

export interface PayoutOrderPlan {
  id: string;
  name: string;
  accountType: string;
  order: number;
}

export interface PayoutOrderCategory {
  categoryType: CategoryTypeDto;
  services: PayoutOrderService[];
}

export interface PayoutDefinitionFormValues {
  payoutDefinitionName: string;
  mpTableId: string;
  covTableId: string;
  isLimited: boolean;
  categories: PayoutOrderCategory[];
  columnsCount: number;
}
